//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    productUrl: {
      type: String,
      default: '',
    },
    isSelect: {
      type: Boolean,
    },
    founders: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    parseUrl() {
      if (!this.productUrl) return null;

      return {
        label: this.productUrl.replace(/^(?:https?:\/\/)?(?:www\.)?/i, '').split('/')[0],
        value: this.productUrl,
      };
    },
  },
};
